<template lang="html">
  <img src="@/assets/logo.png" alt="Diensten Centrum" width="200" />
  <div class="card-container">
    <h1 class="title">Your code is:</h1>
    <h1 class="code text-secondary">{{ getSavedCode }}</h1>
  </div>
</template>

<script>
export default {
  name: "CodeScreen",
  data: () => ({
    firstName: null,
    lastName: null,
    email: null,
  }),
  computed: {
    getSavedCode() {
      return this.$store.getters.getCode;
    },
  },
  methods: {},
};
</script>

<style lang="css" scoped>
.card-container {
  background-color: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  margin: 20px auto;
}

.title {
  padding-bottom: 10px;
  font-size: 30px;
  color: #1c63af;
}
.code {
  font-size: 50px;
  padding-bottom: 0px;
}
</style>
